import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "@/lib/utils/cn";

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, ...props },
  ref,
) {
  return (
    <input
      ref={ref}
      className={cn(
        "block w-full rounded-lg border border-ink/15 bg-white px-3 py-2 text-sm text-ink placeholder:text-ink-faint",
        "focus-visible:border-brand-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-600/30",
        "disabled:cursor-not-allowed disabled:bg-surface-muted disabled:text-ink-faint",
        "aria-[invalid=true]:border-danger-500 aria-[invalid=true]:focus-visible:ring-danger-500/30",
        className,
      )}
      {...props}
    />
  );
});
